<template>
  <div>
    <v-row>
      <v-col cols="12">
        <heatmap-events-config />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HeatmapEventsConfig from '@/components/configs/heatmapEventsConfig'
export default {
  components: {
    HeatmapEventsConfig
  }
}
</script>